// extracted by mini-css-extract-plugin
module.exports = {"tagsInformation":"TagsInformation_tagsInformation__2_esp","chips":"TagsInformation_chips__2Fzjs"};